module.exports = __webpack_public_path__ + "ae.d038b7ed.svg";